module.exports = __webpack_public_path__ + "static/media/picture1.5a22d305.png";